<template>
  <div>
    <div v-if="loader">
      <div class="spinner"></div>
    </div>

    <!--   Main Content Start Here   -->
    <main>
      <section class="dashboard_wraper">
        <div class="container_large">
          <div class="row">
            <!-- start sidebar component -->
            <sidebar-component></sidebar-component>
            <!-- end sidebar component -->

            <div class="col-md-12 col-lg-9">
              <div class="dashboard_card">
                <h2>Schedule Delivery</h2>
                <!-- Wash & Fold -->
                <div class="schedule_row">
                  <h3>Wash & Fold</h3>
                  <div class="schedule_content">
                    <div class="row">
                      <div class="col-6 col-md-6 col-lg-4">
                        <h4>Earlist Delivery</h4>
                        <h5>No of days from pickup</h5>
                      </div>
                      <div class="col-6 col-md-6 col-lg-8">
                        <div class="schedule_value">
                          <input
                            type="number"
                            name=""
                            value="2"
                            v-model="wash_delivery.value"
                          />
                          <span>Days</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="schedule_content">
                    <div class="row">
                      <div class="col-6 col-md-6 col-lg-4">
                        <h4>Min Order</h4>
                      </div>
                      <div class="col-6 col-md-6 col-lg-8">
                        <div class="schedule_value">
                          <input
                            type="number"
                            name=""
                            value="1"
                            v-model="wash_min_order.value"
                          />
                          <span>Lbs</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Dry Cleaning -->
                <div class="schedule_row">
                  <h3>Dry Cleaning</h3>
                  <div class="schedule_content">
                    <div class="row">
                      <div class="col-6 col-md-6 col-lg-4">
                        <h4>Earlist Delivery</h4>
                        <h5>No of days from pickup</h5>
                      </div>
                      <div class="col-6 col-md-6 col-lg-8">
                        <div class="schedule_value">
                          <input
                            type="number"
                            name=""
                            value="2"
                            v-model="dry_clean_delivery.value"
                          />
                          <span>Days</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="schedule_content">
                    <div class="row">
                      <div class="col-6 col-md-6 col-lg-4">
                        <h4>Min Order</h4>
                      </div>
                      <div class="col-6 col-md-6 col-lg-8">
                        <div class="schedule_value">
                          <span>$</span>
                          <input
                            type="number"
                            name=""
                            value="30"
                            v-model="dry_clean_min_order.value"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Tailoring -->
                <div class="schedule_row">
                  <h3>Tailoring</h3>
                  <div class="schedule_content">
                    <div class="row">
                      <div class="col-6 col-md-6 col-lg-4">
                        <h4>Earlist Delivery</h4>
                        <h5>No of days from pickup</h5>
                      </div>
                      <div class="col-6 col-md-6 col-lg-8">
                        <div class="schedule_value">
                          <input
                            type="number"
                            name=""
                            value="2"
                            v-model="tailoring_delivery.value"
                          />
                          <span>Days</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="schedule_content">
                    <div class="row">
                      <div class="col-6 col-md-6 col-lg-4">
                        <h4>Min Order</h4>
                      </div>
                      <div class="col-6 col-md-6 col-lg-8">
                        <div class="schedule_value">
                          <span>$</span>
                          <input
                            type="number"
                            name=""
                            value="30"
                            v-model="tailoring_min_order.value"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="alert alert-success alert-dismissible"
                  v-if="status && status == 200"
                >
                  <strong>Success!</strong> Action performed successfully.
                </div>
                <div class="order_buttons">
                  <a  class="button primary_button pointer" @click="submit()"
                    >Save</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <!--   Main Content End Here   -->
  </div>
</template>
<script>
import webSettingsApis from "../../Apis/webSettings";
import sidebarComponent from "./sidebar.vue";

export default {
  components: {
    sidebarComponent,
  },
  data() {
    return {
      loader: true,
      settings: null,
      status: null,

      wash_delivery: {
        id: null,
        value: null,
      },
      wash_min_order: {
        id: null,
        value: null,
      },

      dry_clean_delivery: {
        id: null,
        value: null,
      },
      dry_clean_min_order: {
        id: null,
        value: null,
      },

      tailoring_delivery: {
        id: null,
        value: null,
      },
      tailoring_min_order: {
        id: null,
        value: null,
      },
    };
  },
  methods: {
    async getSettings() {
      this.settings = (await webSettingsApis.getScheduleSettings()).data;

      if (this.settings) {
        this.settings.forEach((element) => {
          if (element.key == "min_wash_delivery_days") {
            this.wash_delivery = element;
          }
          if (element.key == "wash_per_lb_price") {
            this.wash_min_order = element;
          }
          if (element.key == "min_dry_clean_price") {
            this.dry_clean_min_order = element;
          }
          if (element.key == "min_dry_clean_delivery_days") {
            this.dry_clean_delivery = element;
          }
          if (element.key == "min_tailoring_price") {
            this.tailoring_min_order = element;
          }
          if (element.key == "min_tailoring_delivery_days") {
            this.tailoring_delivery = element;
          }
        });
      }
      this.loader = false;
    },

    async submit() {
      const complete_obj = {
        wash_deliery: this.wash_delivery,
        wash_min_order: this.wash_min_order,
        dry_clean_delivery: this.dry_clean_delivery,
        dry_clean_min_order: this.dry_clean_min_order,
        tailoring_min_order: this.tailoring_min_order,
        tailoring_delivery: this.tailoring_delivery,
      };
      // console.log(complete_obj);
      this.status = (
        await webSettingsApis.updateScheduleSettings(complete_obj)
      ).status;
      setTimeout(() => {
        this.status = null
      }, 1000);
    },
  },
  created() {
    this.getSettings();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/admin/scheduleDelivery.vue